import { RetriesTabContainer } from '../../retriesTab/RetriesTabContainer';

/** Route element for Retransmisje (/main/dod/retries). */
export const RetriesRoute = (): JSX.Element => <RetriesTabContainer />;
